import React from "react";
import { Resource } from "react-admin";
import { useTokenOps } from "../../components/TokenContext";
import AccountCarbonUpload from "./AccountCarbonUpload";

export const SelectedAccountCarbonUploadPage = () => {
  const tokenOps = useTokenOps();
  const accountId = tokenOps.account?.data?.accountId;

  return <AccountCarbonUpload accountId={accountId} />;
};

export const accountCarbonUploadResource = () => (
  <Resource
    name="accountCarbonUploads"
    options={{ label: "Carbon upload", menuGroup: "Accounts" }}
    list={SelectedAccountCarbonUploadPage}
  />
);

export default accountCarbonUploadResource;
